import React from 'react';

const SupremeLogo = ({ className = "w-12 h-12", animated = true }) => {
  return (
    <svg 
      className={`${className} ${animated ? 'animate-pulse' : ''}`}
      viewBox="0 0 100 100" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="supremeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8B5CF6" />
          <stop offset="50%" stopColor="#EC4899" />
          <stop offset="100%" stopColor="#F59E0B" />
        </linearGradient>
        <filter id="glow">
          <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
          <feMerge> 
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Crown Base */}
      <path 
        d="M20 70 L30 50 L40 60 L50 40 L60 60 L70 50 L80 70 Z" 
        fill="url(#supremeGradient)" 
        filter="url(#glow)"
        className="transition-all duration-300 hover:scale-110"
      />
      
      {/* Crown Jewels */}
      <circle cx="35" cy="55" r="3" fill="#FBBF24" className="animate-ping" />
      <circle cx="50" cy="45" r="4" fill="#EF4444" className="animate-ping" style={{animationDelay: '0.5s'}} />
      <circle cx="65" cy="55" r="3" fill="#10B981" className="animate-ping" style={{animationDelay: '1s'}} />
      
      {/* Supreme Text */}
      <text 
        x="50" 
        y="85" 
        textAnchor="middle" 
        className="fill-white font-bold text-xs"
        style={{fontFamily: 'Arial, sans-serif'}}
      >
        SUPREME
      </text>
    </svg>
  );
};

export default SupremeLogo;
